import { PayloadAction } from '@reduxjs/toolkit'
import { UserState } from '../slices/userSlice'
import { IdTokenData } from '@/features/auth/types/idTokenSchema'

const setData = (state: UserState, action: PayloadAction<IdTokenData>) => {
  state.name = action.payload.name
  state.email = action.payload.email
  state.userId = action.payload.sub
  state.firstName = action.payload.given_name
  state.lastName = action.payload.family_name
  state.siteId = new Number(action.payload.site).valueOf()
}

const setRoles = (state: UserState, action: PayloadAction<Array<string>>) => {
  state.roles = action.payload
}

const setOriginalUser = (state: UserState, action: PayloadAction<UserState>) => {
  state.originalUser = {
    userId: action.payload.userId,
    name: action.payload.name,
    firstName: action.payload.firstName,
    lastName: action.payload.lastName,
    email: action.payload.email,
  }
}

const deleteOriginalUser = (state: UserState) => {
  state.originalUser = undefined
}

const setSelectedTableRows = (
  state: UserState,
  action: PayloadAction<{ tableId: string; rowSelectionState: Array<Record<string, unknown>> }>,
) => {
  state.selectedTableRows[action.payload.tableId] = action.payload.rowSelectionState
}

export { setData, setRoles, setOriginalUser, deleteOriginalUser, setSelectedTableRows }
